const state = {
   property : {
        equipment : false,
   },
   equipmentStructure : {
        equipment : false,
   }

};

const getters = {
    property : (state) => state.property,
    equipmentStructure : (state) => state.equipmentStructure
};

const actions = {

};

const mutations = {
    setProperty (state,data) {
        state.property = {...state.property, [data.key] : data.value }
    },
    setequipmentStructure (state,data) {
        state.equipmentStructure = {...state.equipmentStructure, [data.key] : data.value }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}